module.exports = __webpack_public_path__ + "img/katarina_outside_10.90dc884b.jpg";